import styled from 'styled-components';
import {flexMixin, textMixin} from '../../../../../styles/mixins';
import {colors} from '../../../../../styles';

const legendCallback = (chart, toggleDatasetVisibility, hiddenDatasets) => {
    const {data} = chart;
    return (
        <LegendWrap>
            {data.datasets.map((dataset, i) => (
                <LegendItem key={i} onClick={() => toggleDatasetVisibility(i)}>
                    <LegendColorBox color={dataset.backgroundColor}>
                        {!hiddenDatasets.includes(i) && (
                            <CheckIcon
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 14 11"
                                fill="none"
                                stroke="white"
                            >
                                <path
                                    d="M1.5 3.68778L5.82143 8.61538L12.5 1"
                                    strokeWidth="2"
                                ></path>
                            </CheckIcon>
                        )}
                    </LegendColorBox>
                    <LegendLabel>{dataset.label}</LegendLabel>
                </LegendItem>
            ))}
        </LegendWrap>
    );
};

export function LegendRestContainer({
    datas,
    setHiddenDatasets,
    hiddenDatasets,
}) {
    const toggleDatasetVisibility = (index: number) => {
        setHiddenDatasets((prev) => {
            const newHiddenDatasets = [...prev];
            if (newHiddenDatasets.includes(index)) {
                newHiddenDatasets.splice(newHiddenDatasets.indexOf(index), 1);
            } else {
                newHiddenDatasets.push(index);
            }
            return newHiddenDatasets;
        });
    };

    return (
        <>
            <div id="legend-container">
                {legendCallback(
                    {data: datas},
                    toggleDatasetVisibility,
                    hiddenDatasets
                )}
            </div>
        </>
    );
}

const LegendWrap = styled.ul`
    list-style: none;
    ${flexMixin('row', 'flex-start', 'center')};
    padding-bottom: 10px;
    flex-wrap: wrap;
    gap: 10px;
`;

const LegendItem = styled.li`
    ${flexMixin('row', 'center', 'center')};
    cursor: pointer;
`;

const LegendColorBox = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background-color: ${(props) => props.color};
    border-radius: 2px;
`;

const LegendLabel = styled.span`
    ${textMixin({
        fontSize: '12px',
        fontWeight: 500,
    })};
    line-height: 28px;
    color: ${colors.grey};
`;

const CheckIcon = styled.svg`
    width: 16px;
    height: 16px;
`;
